(ns minorodata.components.data-apps.core
  (:require [minorodata.components.data-apps.utils :refer [cards-data
                                                           dashboard-routes
                                                           data-apps-icon]]
            [reagent.core :as reagent]
            [reitit.frontend.easy :as rt.easy]
            [ui.button :refer [button]]
            [ui.card :refer [card]]
            [ui.dialog :refer [dialog-content dialog-root dialog-title]]
            [ui.page :refer [page-content page-description page-header
                             page-root page-title]]
            [ui.typography :as typography]))


(defn get-modal-data [route-key]
  (let [route (get dashboard-routes route-key)]
    (assoc (:card route)
           :route route-key
           :title (:title route)
           :icon  (:icon route))))

(defn data-app-modal [{:keys [open on-close]
                       {:keys [route icon title modal]} :data}]
  [dialog-root {:open open
                :on-open-change (fn [v]
                                  (when-not v (on-close)))}
   [dialog-content {:class "p-0 max-w-[1024px] dark:bg-white"
                    :size  :large}
    [:div {:class "w-full flex justify-between items-center py-4 pl-8 pr-16 bg-kleene-background-secondary"}
     [dialog-title
      [:div {:class "flex gap-2 mx-auto"}
       (when icon [icon])
       title]]

     (when route
       [:div
        [button {:href     (rt.easy/href route {} {:demo-data-app true})
                 :on-click on-close
                 :variant  :secondary
                 :class    "mr-2"}
         "Demo dashboard"]])]

    [:div {:class "flex justify-center"}
     [:iframe {:src   modal
               :class "w-full h-[calc(100vh_-_200px)]"}]]]])

(defn dashboard-card []
  (let [show? (reagent/atom false)]

    (fn [{:keys [title colors description img] :as data}]
      [:<>
       [card {:class "rounded-3xl overflow-hidden"}
        [:div {:class    "cursor-pointer"
               :on-click #(reset! show? true)}
         [:div {:class "px-4 pt-4"
                :style {:background "linear-gradient(to bottom, var(--from), var(--to))"
                        "--from" (first colors)
                        "--to" (second colors)}}
          [:div {:class "bg-white rounded-t-xl text-center py-2"}
           [:img {:src   img
                  :class "h-[100px]"}]]]
         [:div {:class "flex flex-col gap-2 px-6 pt-4 pb-6"}
          [:header
           [typography/h3 {:class "group-hover:underline"}
            title]]
          [:div
           [typography/p {:class "text-kleene-text-secondary whitespace-pre-wrap"}
            description]]]]]

       [data-app-modal {:data       data
                        :open       @show?
                        :on-close   #(reset! show? false)}]])))

(defn dashboards-section [{:keys [title icon colors cards]}]
  [:div {:class "flex flex-col gap-4"}
   [:div
    [typography/h2 {:class "flex items-center gap-2"}
     (when icon
       [icon {:class      "p-1.5"
              :icon-props {:size 24}}])
     title]]
   [:div {:class "grid grid-cols-3 gap-4"}
    (for [card cards]
      (let [data (get-modal-data card)]
        ^{:key card}
        [dashboard-card (assoc data
                               :colors colors)]))]])

(defn page []
  [page-root
   [page-header {:content-props {:class "flex gap-2"}}
    [:div [data-apps-icon]]
    [:div
     [page-title {:class "mb-1"} "Data apps"]
     [page-description "Advanced data science applications to get the maximum value from your data"]]]

   [page-content {:class "pb-20"}
    [:div {:class "max-w-7xl mx-auto flex flex-col gap-8"}
     (for [{:keys [title] :as data} (cards-data)]
       ^{:key title}
       [dashboards-section data])]]])
